import { StreamRoleId } from '@mimir/common/dto/mediaAvailability';
import type { StreamSetPreference } from '@mimir/common/dto/mediaDtos';

const browsePreviewCmafSplitStream: StreamRoleId[] = [
  StreamRoleId.BrowsePreviewVideo,
  StreamRoleId.BrowsePreviewAudioDownmix
];

const browsePreviewCmafMultiStream: StreamRoleId[] = [
  StreamRoleId.BrowsePreviewVideoAudioDownMix
];

const browsePreviewTsStreams: StreamRoleId[] = [
  StreamRoleId.LiveRecordWebproxyTs
];

const highresTsStreams: StreamRoleId[] = [
  StreamRoleId.LiveRecordHighresTs
];

const audioTsStreams: StreamRoleId[] = [
  StreamRoleId.LiveRecordAudioOnlyHighresTs,
  StreamRoleId.LiveRecordAudioOnlyProxyTs,
];

export const preferLowBandwidth: StreamSetPreference = [
  browsePreviewTsStreams,
  audioTsStreams,
  browsePreviewCmafSplitStream,
  browsePreviewCmafMultiStream,
  highresTsStreams
];

export const preferQuality: StreamSetPreference = [
  highresTsStreams,
  browsePreviewTsStreams,
  audioTsStreams,
  browsePreviewCmafSplitStream,
  browsePreviewCmafMultiStream
];
